import ProductsApi from "@ROM/Products/api";

export async function loadOptions(searchInput, _loadedOptions, { page }) {
  const result = await ProductsApi.list({
    name: searchInput,
    page,
  });

  const options = result.data.data.map((option) => {
    const { name, sku } = option.attributes;
    const labelWithSku = sku ? `${name} - ${sku}` : name;

    return {
      value: option.id,
      label: labelWithSku,
    };
  });

  return {
    options,
    hasMore: result.data.meta.pagination.currentPage < result.data.meta.pagination.totalPages,
    additional: {
      page: page + 1,
    },
  };
}